(() => {
  'use strict';

  const STYLE_ID = 'rr-adaptive-header-style';
  const ACTIVE_CLASS = 'rr-adaptive-header';
  const DARK = '#0b0b0b';
  const LIGHT = '#ffffff';

  const addStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .header-section.${ACTIVE_CLASS} .header__column--left {
        color: var(--rr-header-left, ${LIGHT}) !important;
      }
      .header-section.${ACTIVE_CLASS} .header__column--center {
        color: var(--rr-header-center, ${LIGHT}) !important;
      }
      .header-section.${ACTIVE_CLASS} .header__column--right {
        color: var(--rr-header-right, ${LIGHT}) !important;
      }
      .header-section.${ACTIVE_CLASS} :is(.header__column--left,.header__column--center,.header__column--right)
      :is(.menu-list__link,.header-actions__action,.dropdown-localization__button,.header__icon--menu,summary,button) {
        color: inherit !important;
      }
      .header-section.${ACTIVE_CLASS} :is(.header__column--left,.header__column--center,.header__column--right)
      :is(svg,path) {
        color: inherit;
      }
      @media (max-width: 749px) {
        .header-section.${ACTIVE_CLASS} .header__column--left {
          --rr-header-left: var(--rr-header-mobile, ${LIGHT});
        }
        .header-section.${ACTIVE_CLASS} .header__column--right {
          --rr-header-right: var(--rr-header-mobile, ${LIGHT});
        }
      }
    `;
    document.head.appendChild(style);
  };

  const luminance = (r, g, b) => {
    const convert = (value) => {
      value /= 255;
      return value <= 0.04045 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * convert(r) + 0.7152 * convert(g) + 0.0722 * convert(b);
  };

  const contrastColor = (value) => value > 0.42 ? DARK : LIGHT;

  const init = () => {
    const main = document.querySelector('#MainContent');
    if (!main || !String(main.dataset.template || '').includes('collection')) return;

    const headerSection = document.querySelector('.header-section');
    const header = document.querySelector('#header-component');
    const hero = document.querySelector('.rr-collection-hero, [class*="collection"][class*="hero"], #MainContent > section:first-child');
    if (!headerSection || !header || !hero) return;

    addStyles();

    let colors = [LIGHT, LIGHT, LIGHT];

    const setActiveState = () => {
      const heroRect = hero.getBoundingClientRect();
      const headerHeight = Math.max(headerSection.getBoundingClientRect().height, 64);
      const isOverHero = heroRect.top < headerHeight && heroRect.bottom > headerHeight;
      const isTransparent = header.hasAttribute('transparent') || headerSection.classList.contains('header-section--transparent');

      if (!isOverHero || !isTransparent) {
        headerSection.classList.remove(ACTIVE_CLASS);
        return;
      }

      headerSection.style.setProperty('--rr-header-left', colors[0]);
      headerSection.style.setProperty('--rr-header-center', colors[1]);
      headerSection.style.setProperty('--rr-header-right', colors[2]);
      headerSection.style.setProperty('--rr-header-mobile', colors[1]);
      headerSection.classList.add(ACTIVE_CLASS);
    };

    const sampleImage = () => {
      const visibleImage = hero.querySelector('img');
      if (!visibleImage || !(visibleImage.currentSrc || visibleImage.src)) {
        setActiveState();
        return;
      }

      const source = new Image();
      source.crossOrigin = 'anonymous';

      source.onload = () => {
        try {
          const box = hero.getBoundingClientRect();
          const sourceWidth = source.naturalWidth;
          const sourceHeight = source.naturalHeight;
          const scale = Math.max(box.width / sourceWidth, box.height / sourceHeight);
          const cropX = Math.max(0, (sourceWidth * scale - box.width) / (2 * scale));
          const cropY = Math.max(0, (sourceHeight * scale - box.height) / (2 * scale));
          const visibleWidth = Math.min(sourceWidth - cropX, box.width / scale);
          const headerBand = Math.min(sourceHeight - cropY, Math.max(80, headerSection.offsetHeight) / scale);

          const canvas = document.createElement('canvas');
          canvas.width =  96;
          canvas.height = 12;
          const context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(source, cropX, cropY, visibleWidth, headerBand, 0, 0, canvas.width, canvas.height);
          const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
          const totals = [0, 0, 0];
          const counts = [0, 0, 0];

          for (let y = 0; y < canvas.height; y += 1) {
            for (let x = 0; x < canvas.width; x += 1) {
              const index = (y * canvas.width + x) * 4;
              const region = Math.min(2, Math.floor(x / (canvas.width / 3)));
              const imageLum = luminance(pixels[index], pixels[index + 1], pixels[index + 2]);
              const position = x / (canvas.width - 1);
              const shade = position < 0.55
                ? 0.68 - (position / 0.55) * 0.40
                : 0.28 - ((position - 0.55) / 0.45) * 0.20;
              totals[region] += imageLum * (1 - Math.max(0.08, shade));
              counts[region] += 1;
            }
          }

          colors = totals.map((total, index) => contrastColor(total / counts[index]));
        } catch (error) {
          colors = [LIGHT, LIGHT, LIGHT];
        }
        setActiveState();
      };

      source.onerror = setActiveState;
      source.src = visibleImage.currentSrc || visibleImage.src;
    };

    sampleImage();
    window.addEventListener('scroll', setActiveState, { passive: true });
    window.addEventListener('resize', sampleImage, { passive: true });
    new MutationObserver(setActiveState).observe(header, {
      attributes: true,
      attributeFilter: ['transparent', 'data-sticky-state', 'class']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* Racrabbit language flags — active locale + localization menu */
(() => {
  'use strict';

  const FLAG_CLASS = 'rr-language-flag';
  const localeFrom = (element, fallback = '') => {
    const raw = [
      element?.getAttribute?.('hreflang'),
      element?.getAttribute?.('lang'),
      element?.dataset?.locale,
      element?.dataset?.value,
      element?.value,
      element?.textContent,
      fallback
    ].filter(Boolean).join(' ').toLowerCase();

    if (/\b(pt|pt-br|portugu[eê]s|portuguese|brasil|brazil)\b/.test(raw)) return 'pt';
    if (/\b(es|es-es|español|espanol|spanish|españa|spain)\b/.test(raw)) return 'es';
    if (/\b(en|en-us|english|ingl[eê]s|usa|united states)\b/.test(raw)) return 'en';
    return '';
  };

  const flagFor = (locale) => ({ pt: '🇧🇷', es: '🇪🇸', en: '🇺🇸' }[locale] || '');

  const createFlag = (locale) => {
    const flag = document.createElement('span');
    flag.className = `${FLAG_CLASS} ${FLAG_CLASS}--${locale}`;
    flag.setAttribute('aria-hidden', 'true');
    flag.textContent = flagFor(locale);
    return flag;
  };

  const decorate = (element, fallback) => {
    if (!element || element.tagName === 'SELECT' || element.querySelector(`.${FLAG_CLASS}`)) return;
    const locale = localeFrom(element, fallback);
    if (!locale) return;
    element.prepend(createFlag(locale));
    element.classList.add('rr-language-with-flag');
  };

  const enhance = () => {
    const activeLocale = document.documentElement.lang || 'en';

    document.querySelectorAll(
      '.dropdown-localization__button, localization-form summary, [data-localization-button], .localization-form__select:not(select)'
    ).forEach((element) => decorate(element, activeLocale));

    document.querySelectorAll(
      'a[hreflang], [data-locale], .localization-form__link, .language-selector__link, .dropdown-localization__item a'
    ).forEach((element) => decorate(element));
  };

  const addFlagStyles = () => {
    if (document.getElementById('rr-language-flag-style')) return;
    const style = document.createElement('style');
    style.id = 'rr-language-flag-style';
    style.textContent = `
      .rr-language-with-flag {
        display: inline-flex !important;
        align-items: center;
        gap: 0.55rem;
      }

      .${FLAG_CLASS} {
        width: 1.35rem;
        height: 1.35rem;
        min-width: 1.35rem;
        display: inline-grid;
        place-items: center;
        overflow: hidden;
        border-radius: 50%;
        background: #fff;
        border: 1px solid color-mix(in srgb, currentColor 35%, transparent);
        box-shadow: 0 1px 4px rgb(0 0 0 / 18%);
        font-size: 1.15rem;
        line-height: 1;
        letter-spacing: 0;
      }

      .header-section.rr-adaptive-header .header__column--right
      .dropdown-localization__button {
        color: var(--rr-header-right, #fff) !important;
      }

      .header-section.rr-adaptive-header .header__column--right
      .dropdown-localization__button :is(svg, path) {
        color: inherit;
      }
    `;
    document.head.appendChild(style);
  };

  const initLanguageFlags = () => {
    addFlagStyles();
    enhance();

    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        enhance();
        scheduled = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanguageFlags, { once: true });
  } else {
    initLanguageFlags();
  }
})();

/* Racrabbit collection header parity — transparent hero, solid header after scroll */
(() => {
  'use strict';

  const SOLID_CLASS = 'rr-collection-header-solid';

  const addStyles = () => {
    if (document.getElementById('rr-collection-header-parity-style')) return;

    const style = document.createElement('style');
    style.id = 'rr-collection-header-parity-style';
    style.textContent = `
      .header-section.${SOLID_CLASS},
      .header-section.${SOLID_CLASS} #header-component,
      .header-section.${SOLID_CLASS} .header,
      .header-section.${SOLID_CLASS} .header__row {
        background: #ffffff !important;
        background-color: #ffffff !important;
        color: #0b0b0b !important;
        --color-background: 255 255 255;
        --color-foreground: 11 11 11;
        --color-foreground-rgb: 11 11 11;
      }

      .header-section.${SOLID_CLASS} {
        box-shadow: 0 1px 0 rgb(0 0 0 / 10%);
      }

      .header-section.${SOLID_CLASS}
      :is(.header__column--left, .header__column--center, .header__column--right) {
        color: #0b0b0b !important;
      }

      .header-section.${SOLID_CLASS}
      :is(
        .menu-list__link,
        .header-actions__action,
        .dropdown-localization__button,
        .header__icon--menu,
        .localization-form__select,
        summary,
        button
      ) {
        color: #0b0b0b !important;
      }

      .header-section.${SOLID_CLASS}
      :is(
        .menu-list__link,
        .header-actions__action,
        .dropdown-localization__button,
        .header__icon--menu,
        .localization-form__select,
        summary,
        button
      ) :is(svg, path) {
        color: #0b0b0b !important;
      }

      .header-section.${SOLID_CLASS}.rr-adaptive-header {
        --rr-header-left: #0b0b0b !important;
        --rr-header-center: #0b0b0b !important;
        --rr-header-right: #0b0b0b !important;
        --rr-header-mobile: #0b0b0b !important;
      }

      @media (prefers-reduced-motion: no-preference) {
        .header-section,
        .header-section #header-component,
        .header-section .header__row {
          transition:
            background-color 180ms ease,
            color 180ms ease,
            box-shadow 180ms ease;
        }
      }
    `;

    document.head.appendChild(style);
  };

  const initCollectionHeaderParity = () => {
    const main = document.querySelector('#MainContent');
    const headerSection = document.querySelector('.header-section');
    if (!main || !headerSection || !String(main.dataset.template || '').includes('collection')) return;

    addStyles();

    const update = () => {
      const shouldBeSolid = window.scrollY > 8;
      headerSection.classList.toggle(SOLID_CLASS, shouldBeSolid);

      if (shouldBeSolid) {
        headerSection.classList.remove('rr-adaptive-header');
      }
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('pageshow', update);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionHeaderParity, { once: true });
  } else {
    initCollectionHeaderParity();
  }
})();